import MenuPage from './table.vue';

export default MenuPage;
